<template>
  <div class="filter-dialog">
    <ScpmSearchField
      :items="props.schema.fields"
      :searchFieldActive="searchFieldActive"
      @search="onSearchField"
      ref="searchField"
      @clear="onClear"
      @changeKeyword="onChangeKeyword"
      :searchTarget="searchTarget"
      width="410"
      :placeholder="placeholder"
      :labelTarget="labelTarget"
    />
    <scpm-popover
      right="0"
      :open="isOpenPopover"
      @close="closePopover"
      class="filter-dialog__details"
    >
      <template #target>
        <lego-button @click="changePopoverStatus" :class="{ active: countFilter }"
          >{{ $t('button.details') }}
          {{ countFilter ? ` (${countFilter})` : '' }}
        </lego-button>
      </template>
      <div>
        <scpm-filter
          :key="resetComponentKey"
          :schema="schema"
          :model="model"
          @reset="onReset()"
          @search="onSearch()"
        />
      </div>
    </scpm-popover>
  </div>
</template>
<script>
export default {
  name: 'scpm-filter-dialog'
};
</script>

<script setup>
import {
  defineProps,
  defineEmits,
  ref,
  computed,
  onMounted,
  onUnmounted,
  watch,
  watchEffect
} from 'vue';

import ScpmSearchField from './ScpmSearchField.vue';
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';
import _ from 'lodash';
import { useStore } from 'vuex';

//props
const props = defineProps({
  schema: {
    type: Object,
    default: () => {}
  },
  model: {
    type: Object,
    default: () => {}
  },
  cols: {
    type: Number,
    default: 1
  },
  widthFilter: {
    type: [Number, String],
    default: 415
  },
  searchTarget: {
    type: Boolean,
    default: false
  },
  labelTarget: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String
  }
});

//emits
const emits = defineEmits([
  'search',
  'reset',
  'searchField',
  'resetModel',
  'clearTxtkey',
  'changeKey'
]);
const $store = useStore();
const isOpenPopover = ref(false);
const searchFieldActive = ref();
const searchField = ref(null);
const countFilter = ref(0);
const modelClone = ref(null);
const resetComponentKey = ref(0);
const isResetFilterXss = computed(() => $store.getters['searchStore/getResetFilterXss']);
// function
onMounted(() => {
  legoEventBus.$on('click-outside', () => {
    closePopover();
  });
  setCountFilter();
});

onUnmounted(() => {
  legoEventBus.$off('click-outside', () => {
    closePopover();
  });
});

const changePopoverStatus = () => {
  if (!isOpenPopover.value) {
    modelClone.value = _.cloneDeep(props.model);
    isOpenPopover.value = true;
  } else {
    closePopover();
  }
};

const closePopover = () => {
  if (isOpenPopover.value) {
    isOpenPopover.value = false;

    updateModel();
  }
};

const updateModel = () => {
  if (modelClone.value) {
    const model = props.model;
    for (const key in model) {
      model[key] = modelClone.value[key];
    }
  }
};

const onSearchField = (item, value) => {
  modelClone.value = null;
  emits('searchField', item.model, value);
  searchFieldActive.value = value ? item : null;
  countFilter.value = 0;
  resetComponentKey.value += 1;
};

const onClear = () => {
  searchFieldActive.value = null;
  searchField.value.clearSearchValue();
  emits('clearTxtkey');
};

const clearSearchField = () => {
  searchFieldActive.value = null;
  searchField.value.clearSearchValue();
  closePopover();
};

const onReset = (status) => {
  modelClone.value = null;
  emits('reset', status);
  clearSearchField();
  countFilter.value = 0;
  if (!status) {
    resetComponentKey.value += 1;
  }
};

const onSearch = () => {
  modelClone.value = _.cloneDeep(props.model);
  emits('search');
  clearSearchField();
  setCountFilter();
};
const isEmpty = (str) => {
  return str === null || str === undefined || str === '';
};
const setCountFilter = () => {
  const total = Object.keys(props.model).reduce((count, key) => {
    if (key !== 'productTypeCode' && !isEmpty(props.model[key]) && props.model[key].length > 0) {
      return count + 1;
    }
    return count;
  }, 0);
  countFilter.value = total;
};
const setDefaultResetFilterXss = () => $store.dispatch('searchStore/setDefaultResetFilterXss');

const onChangeKeyword = (value) => {
  emits('changeKey', value);
};

const onSetAgainKeyword = (val) => {
  const preTxtIndex = props.schema.fields.findIndex((item) => item.searchActive);
  // Update for prefix default for case not prefix label
  if (!searchFieldActive.value && preTxtIndex > -1 && val) {
    searchFieldActive.value = props.schema.fields[preTxtIndex];
  }
  searchField.value.setKeywordSearch(val);
};

// watch
watch(
  () => props.model.productTypeCode,
  () => {
    clearSearchField();
    countFilter.value = 0;
  }
);

defineExpose({
  clearSearchField,
  onSetAgainKeyword,
  onClear,
  setCountFilter,
  onReset
});
</script>

<style scoped lang="scss">
.filter-dialog {
  display: flex;
  gap: 8px;

  :deep(button.lego-button.active) {
    background-color: #ffffff;
    border-color: #2c59d9;
    color: #2c59d9;
  }

  .filter-dialog__details {
    :deep(.scpm-popover__main) {
      width: auto !important;
    }
  }
}
</style>
